import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalAction,
  GlobalPut,
  OfferSavedWithCryptIdPayload,
  UPDATE_DOCUMENTS_EVENTS,
  UpdateDocumentAdditionalData,
} from '@ps20-frontend/shop-integration-redux';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { selectUwUploadIds } from '../selectors/warenkorb.selector';
import { isSdwSession } from '../selectors/transient-state.selector';

export function* watchOfferSavedWithCryptId() {
  yield takeEvery(
    GlobalActions.OFFER_SAVED_WITH_CRYPTID,
    safeSaga(updateVwgDocumentsAfterSaveSaga, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    UPDATE_DOCUMENTS_EVENTS.UPDATE_DOCUMENTS_SUCCESSFUL,
    safeSaga(updateDocumentSuccessCallback, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    UPDATE_DOCUMENTS_EVENTS.UPDATE_DOCUMENTS_FAILED,
    safeSaga(updateDocumentErrorCallback, App.SHOP_DASHBOARD),
  );
}

export function* updateVwgDocumentsAfterSaveSaga(action: GlobalAction<OfferSavedWithCryptIdPayload>) {
  const { cryptId } = action.payload;
  const state: IAppState = yield select();
  const uploadIds = selectUwUploadIds(state);

  if (!uploadIds || uploadIds.length === 0) {
    return;
  }

  const globalActions = new GlobalActions();
  yield call(
    GlobalPut.getInstance().put,
    globalActions.updateDocumentsWithCryptId({
      documentIds: uploadIds,
      cryptId: cryptId,
      appId: App.SHOP_DASHBOARD,
      isSdwSession: isSdwSession(state),
    }),
  );
}

export function* updateDocumentSuccessCallback(action: DoRequestResponse<unknown>) {
  const additionalData = action.doRequestAction?.payload?.additionalData as UpdateDocumentAdditionalData | undefined;
  const documentId = additionalData?.documentId;

  if (documentId) {
    yield call([PS20Logger, PS20Logger.info], App.SHOP_DASHBOARD, `Document ${documentId} updated successfully`);
  }
}

export function* updateDocumentErrorCallback(action: DoRequestResponse<unknown>) {
  const additionalData = action.doRequestAction?.payload?.additionalData as UpdateDocumentAdditionalData | undefined;
  const documentId = additionalData?.documentId;

  if (documentId) {
    yield call(
      [PS20Logger, PS20Logger.error],
      App.SHOP_DASHBOARD,
      `Document ${documentId} update failed`,
      JSON.stringify(action.payload),
    );
  }
}
